import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatINR(value: number): string {
  return value.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

// True only where a tel: link actually opens a phone dialer. On a Windows /
// Mac desktop with no tel: handler the OS pops an "How do you want to open
// this?" app-picker (Chrome / Edge / People / Phone Link / Store) instead of
// dialing anything — so callers must check this before navigating to tel:.
export function canPlaceTelCall(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/Android|iPhone|iPad|iPod|Mobile|Tel/i.test(ua)) return true;
  if (typeof window !== "undefined" && typeof window.matchMedia === "function") {
    try {
      if (window.matchMedia("(pointer: coarse)").matches && navigator.maxTouchPoints > 1) return true;
    } catch { return false; }
  }
  return false;
}
